import type {ReactElement} from 'react';
import {CostTag} from '@Components/cost-tag';
import {SourceTag} from '@Components/source-tag';
import type {GridMediaItemTag} from '@Components/base-grid/components/grid-media-item';
import {GridMediaItemTagType} from '@Components/base-grid/components/grid-media-item';
import type {GridItemTagProps} from './grid-item-tag.types';
import styles from './grid-item-tag.module.scss';

function getContainerClasses(tag: GridMediaItemTag): string {
  return tag.type === GridMediaItemTagType.COST ? styles.costTagContainer : styles.sourceTagContainer;
}

function getTagForType(tag: GridMediaItemTag): ReactElement {
  if (tag.type === GridMediaItemTagType.COST) {
    return <CostTag containerStyle={tag.containerStyle} textStyle={tag.textStyle} icon={tag.icon} price={tag.price} />;
  }
  return <SourceTag isPremium={tag.type === GridMediaItemTagType.PREMIUM_SOURCE} />;
}

export function GridItemTag({tag}: GridItemTagProps): ReactElement | null {
  if (!tag) {
    return null;
  }

  return <div className={`${getContainerClasses(tag)} _full-width _full-height`}>{getTagForType(tag)}</div>;
}
